import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";
import { useLenis } from "../../hooks/useLenis";

export const Layout = ({ children }) => {
  useLenis();
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="grain min-h-screen bg-korio-bg text-white">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <CookieConsent />
    </div>
  );
};
